import React from 'react';
import PropTypes from 'prop-types';

const WorkExpTimeContainer = ({ children, gb_seniority_improvement_conversion }) => {
  return gb_seniority_improvement_conversion === 'sic_banner_change' ? (
    <div className="new-work-exp-time-wrapper-new">
      {children}
    </div>
  ) : (
    <div className="new-work-exp-time-wrapper">
      {children}
    </div>
  );
};

WorkExpTimeContainer.propTypes = {
  children: PropTypes.any,
  gb_seniority_improvement_conversion: PropTypes.string
};

export default WorkExpTimeContainer;
